import React from 'react';
import { Link } from 'react-router-dom';
import { FiBriefcase } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner container-wide">
        <div className="footer-grid">
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand">
              <FiBriefcase />
              <span>Placement<span className="brand-accent">Hunter</span></span>
            </Link>
            <p className="footer-tagline">
              South Africa's dedicated employment platform connecting talented professionals 
              with leading employers. No noise, just jobs.
            </p>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/careers">Careers</Link>
          </div>

          <div className="footer-col">
            <h4>Job Seekers</h4>
            <Link to="/jobs">Browse Jobs</Link>
            <Link to="/companies">Companies</Link>
            <Link to="/career-resources">Career Resources</Link>
          </div>

          <div className="footer-col">
            <h4>Employers</h4>
            <Link to="/post-job">Post a Job</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/recruitment-solutions">Recruitment Solutions</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} PlacementHunter. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
